import moment from "moment-timezone";

export default (all = false) => {
    try {
        //return moment.tz.guess();
        if (all) {
            return moment.tz.names();
        } else {
            return moment.tz.guess(true);
        }
    } catch (err) {
        console.log('KS-APP: ', err);
        return null;
    }
}
